import { render } from "./DxtPackagesManagement.vue?vue&type=template&id=ea5fe1b6&scoped=true"
import script from "./DxtPackagesManagement.vue?vue&type=script&lang=js"
export * from "./DxtPackagesManagement.vue?vue&type=script&lang=js"

import "./DxtPackagesManagement.vue?vue&type=style&index=0&id=ea5fe1b6&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-ea5fe1b6"

export default script